import { memo } from 'react'

import { useTranslation } from 'react-i18next'

import { Tab } from '@shared/components/MaterialUIEnhancements/Tabs'
import { StatelessTabs } from '@shared/components/MaterialUIEnhancements/Tabs/StatelessTabs'

export type ViewMode = 'simple' | 'json'

export type ViewModeToggleProps = {
  mode: ViewMode
  onChange: (mode: ViewMode) => void
}

/** Shared Simple ⇄ JSON switch for the event Config and Status tabs. */
const ViewModeToggleRaw = ({ mode, onChange }: ViewModeToggleProps) => {
  const { t } = useTranslation(['domain'])

  return (
    <StatelessTabs variant="navigation" value={mode} setActiveTab={(id) => onChange(id as ViewMode)}>
      <Tab id="simple">{t('domain:Workspace.Event.ConfigEditor.simple')}</Tab>
      <Tab id="json">{t('domain:Workspace.Event.ConfigEditor.json')}</Tab>
    </StatelessTabs>
  )
}

export const ViewModeToggle = memo(ViewModeToggleRaw)
